import styled from 'styled-components'

export const FooterContainer = styled.div`
  width: 100%;
  padding: 36px 36px 24px;
  font-size: 1.4rem;
  color: var(--mediumGrey);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  white-space: nowrap;
  margin-top: auto;

  & a {
    color: var(--orange);

    &:hover {
      color: var(--lightGrey);
    }
  }

  @media (max-width: 320px) {
    font-size: 1.2rem;
    gap: 16px;
  }
`
